export default "__VITE_ASSET__DZH2NWp7__"